import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-nav',
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.scss']
})
export class MobileNavComponent implements OnInit {
  @Input() navigation: any[] = [];
  @Input() isOpen: boolean = false;
  @Output() onClose = new EventEmitter<void>();
  @Output() onItemClick = new EventEmitter<any>();

  public expandedItems: Set<string> = new Set();

  constructor(private router: Router) {}

  ngOnInit() {
    console.log('MobileNavComponent initialized');
    console.log('Navigation items:', this.navigation);
    console.log('Is open:', this.isOpen);
    
    // Force visibility if component is rendered
    setTimeout(() => {
      const menuElement = document.querySelector('.mobile-nav-menu');
      if (menuElement) {
        console.log('Mobile nav menu element found:', menuElement);
        console.log('Menu classes:', menuElement.classList.toString());
      } else {
        console.log('Mobile nav menu element NOT found');
      }
    }, 100);
  }

  toggleSubmenu(itemId: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.expandedItems.has(itemId)) {
      this.expandedItems.delete(itemId);
    } else {
      this.expandedItems.add(itemId);
    }
  }

  onMenuItemClick(item: any, event: Event) {
    if (item.type === 'collapse' && item.children) {
      this.toggleSubmenu(item.id, event);
    } else if (item.type === 'item' && item.url) {
      this.router.navigate([item.url]);
      this.onItemClick.emit(item);
      this.closeMenu();
    }
  }

  onSubmenuItemClick(item: any, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (item.url) {
      this.router.navigate([item.url]);
      this.onItemClick.emit(item);
      this.closeMenu();
    }
  }

  closeMenu() {
    this.onClose.emit();
  }

  isExpanded(itemId: string): boolean {
    return this.expandedItems.has(itemId);
  }

  hasChildren(item: any): boolean {
    return item.type === 'collapse' && item.children && item.children.length > 0;
  }
}
